// Module
var code = "<div class=\"menu-button-container\"> <button type=\"button\" class=\"hamburger is-closed animated fadeInLeft\" data-toggle=\"offcanvas\" ng-click=\"open()\"> <i class=\"glyphicon glyphicon-menu-hamburger\"></i> </button> </div>";
// Exports
export default code;